'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.sliders = twentyninetimes.sliders || function () {

	function init() {
		var sliders = document.querySelectorAll('.js-slider');

		if ( sliders ) {
			sliderFunction(sliders);
		}
	}

	function sliderFunction(sliders) {
		sliders.forEach(slider => {
			var slider_wrapper = slider.querySelector('.js-slider__items-wrapper'),
				nav_prev = slider.querySelector('.js-slider__nav .slider-nav.prev'),
				nav_next = slider.querySelector('.js-slider__nav .slider-nav.next'),
				perPage = 4;

			if ( window.innerWidth < 576 ) {
				if ( !slider.classList.contains('loaded') ) {
				    slider.classList.add('loaded');
				}

				return;
			}

			slider.classList.add('has-slider');

			if ( window.innerWidth > 575 && window.innerWidth < 767 ) {
				perPage = 2;
			} else if ( window.innerWidth > 767 && window.innerWidth < 992 ) {
				perPage = 3;
			}

			// Init Siema slider
			let siema_slider = new Siema({
			    selector: slider_wrapper,
			    perPage: perPage,
			    threshold: 20,
			    loop: false,
			    duration: 600,
			    draggable: true,
			    easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
			    onInit: sliderInit,
			    onChange: sliderOnChange
			});

			// Call slider navigation function
			sliderNav(siema_slider, nav_prev, nav_next);
		});
	}

	function sliderInit() {
		var slider = this.selector.parentNode,
			i = this.currentSlide,
			current = this.innerElements[i],
			slides = this.innerElements.length;

		// Check if already has class "loaded", else add it
	    if ( !slider.classList.contains('loaded') ) {
	        slider.classList.add('loaded');
	    }

	    navState(slides, i, this);
	}

	function sliderOnChange() {
	    var current = this.currentSlide,
	        elements = this.innerElements;

	    for (var i = 0; i < elements.length; i++) {
	    	if ( i == current ) {
	    		// Add active class to the current slide
	    	 	elements[i].classList.add('active');
	    	} else {
	    		// Remove the active class if not the current slide
	    		elements[i].classList.remove('active');
	    	}

	    }	    
    	
    	navState(elements.length, current, this);
	}

	function sliderNav(slider, prev, next) {
		if ( prev && next ) {
			// Previous Siema slide
			prev.addEventListener('click', function(e) {
				e.stopPropagation();

			    slider.prev();
			});

			// Next Siema slide
			next.addEventListener('click', function(e) {
				e.stopPropagation();

			    slider.next();
			});
		}
	}

	function navState(i, current, slider) {
		var nav_prev = slider.selector.parentNode.querySelector('.js-slider__nav .slider-nav.prev'),
			nav_next = slider.selector.parentNode.querySelector('.js-slider__nav .slider-nav.next');

		if ( nav_prev && nav_next ) {
			((i-slider.perPage) == current)
				? nav_next.classList.add('disabled')
				: nav_next.classList.remove('disabled');

			( 0 == current )
				? nav_prev.classList.add('disabled')
				: nav_prev.classList.remove('disabled');
		}
	}

	return {
		init : init
	};

}();